import { showGlobalDialogError } from "../components/error";

// Function to clear all session storage
export const clearAllLocalStorage = async () => {
	showGlobalDialogError(
		'Session Expired',
		'',
		{ redirectToLogin: true }
	);
}